module.exports = __webpack_public_path__ + "static/media/funny.74997db6.gif";